import { api } from './client';

export type MaintenanceSeverity = 'INFO' | 'WARNING' | 'MAINTENANCE' | 'OUTAGE';

export interface PublicHealth {
    maintenanceMode: boolean;
    maintenanceSeverity?: MaintenanceSeverity | null;
    maintenanceText?: string | null;
}

export const getHealth = async (): Promise<PublicHealth> => {
    const response = await api.get('/system/health');
    return response.data;
};
